export default __webpack_public_path__ + "static/cover_od_v2-c53ad65afb9604a1c595b72d844608e6.png";